import { useWatch } from "react-hook-form";
import {
  Button,
  ButtonGroup,
  HStack,
  ModalBody,
  ModalFooter,
  Stack,
  Text,
} from "@chakra-ui/react";

import { useCustomerContext } from "contexts/CustomerProvider";
import PrimaryButton from "components/PrimaryButton";
import { RequestModal } from "components/RequestModals";
import {
  filterOutEmptyLineItems,
  RequestContractFormLineItem,
  RequestContractFormProps,
} from "forms/RequestContractForm";
import { DEFAULT_EMPTY_VALUE } from "util/statHelpers";
import { BasicInfoStats, LineItems } from "./components";

const RequestContractConfirmationModal = ({
  uom = DEFAULT_EMPTY_VALUE,
  isOpen,
  onClose,
  onConfirm,
}: {
  uom?: string;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) => {
  const { selectedCustomers } = useCustomerContext();
  const formData = useWatch<RequestContractFormProps>();

  return (
    <RequestModal
      isOpen={isOpen}
      onClose={onClose}
      header={
        <Stack spacing={4}>
          <Text textStyle="h4">{selectedCustomers[0]?.name}</Text>
          <Text textStyle="body2" fontWeight="semibold" color="grey.700">
            Please confirm your contract request below. This is not an active
            contract until confirmed by IRM.
          </Text>
          <HStack spacing={1}>
            <Text textStyle="body2" fontWeight="semibold" color="grey.500">
              PO #:
            </Text>
            <Text textStyle="body2" fontWeight="normal" color="grey.600">
              {formData.poNumber}
            </Text>
          </HStack>
        </Stack>
      }
    >
      <ModalBody px={0} maxH="50vh" overflowY="auto">
        <Stack spacing={4}>
          <BasicInfoStats
            uom={uom}
            formData={formData as RequestContractFormProps}
          />
          <LineItems
            lineItems={(
              formData.lineItems as RequestContractFormLineItem[]
            ).filter(filterOutEmptyLineItems)}
          />
        </Stack>
      </ModalBody>
      <ModalFooter pb={6}>
        <ButtonGroup alignSelf="flex-end">
          <Button variant="secondary" colorScheme="grey" onClick={onClose}>
            Back
          </Button>
          <PrimaryButton onClick={onConfirm}>Request</PrimaryButton>
        </ButtonGroup>
      </ModalFooter>
    </RequestModal>
  );
};

export default RequestContractConfirmationModal;
